/* eslint-disable react/jsx-props-no-spreading */
import React from "react"
import { useField } from "formik"
import { css } from "@jsUtils"

import Styles from "./selectField.module.scss"

/**
 * SelectField input wrapper around html input fields
 * @param {object} props - react props
 * @param {string} props.label - string label for form element
 * @param {string} props.theme - theme for the background,
 * @param {string} props.color - color scheme for the input
 * @param {string} props.variant - variant style for the input
 * @param {*} props._ - additional attributes as necessary
 */
const SelectField = ({
  label,
  theme,
  color,
  variant,
  className,
  inputStyle,
  children,
  isOptional,
  ...props
}) => {
  const { id, name } = props
  const [field, meta] = useField(props)
  const [selectLabel, setSelectLabel] = React.useState(null)
  const selectRef = React.useRef(null)
  const updateLabel = select => {
    // Timeout prevents formik on change event from interfering
    setTimeout(() => {
      const currentOption = select.options[select.selectedIndex].text
      setSelectLabel(currentOption)
    }, 0)
  }
  const onChange = e => {
    updateLabel(e.target)
  }
  React.useEffect(() => {
    updateLabel(selectRef.current)
    selectRef.current.addEventListener("change", onChange)
    return () => {
      selectRef.current.removeEventListener("change", onChange)
    }
  })
  return (
    <div className={css(Styles.wrapper, className)}>
      <div
        className={css(
          Styles.inputWrapper,
          color && Styles[color],
          isOptional && Styles.isOptional,
          variant && Styles[`variant_${variant}`],
          meta.touched && meta.error && Styles.hasError,
          field.value !== "" && field.value !== undefined && Styles.touched
        )}
      >
        <div className={Styles.selectWrapper}>
          <select
            ref={selectRef}
            className={css(Styles.select, inputStyle)}
            id={id || name}
            {...field}
            {...props}
          >
            {children}
          </select>
          <div className={css(Styles.input, inputStyle)}>{selectLabel}</div>
        </div>
        <label className={Styles.label} htmlFor={id || name}>
          {label}
        </label>
      </div>
      {meta.touched && meta.error ? <div className={Styles.error}>{meta.error}</div> : null}
    </div>
  )
}

export default SelectField
